/**
 * Determines whether a FWG AlbumFolder should display the App Download
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
import { ALBUM_TYPE } from '../../../constants/albums';
import { isMobile } from '../../../util/device-detector';
import useIsNativeWebView from '../../../services/native-bridge/hooks/useIsWebView';
import { capitalize } from '../../../util/text';
import { supportedBrowsers } from '../BrowserIcon';

export const shouldDisplayAppDownloadBanner = albumFolder => {
  const isNativeWebView = useIsNativeWebView();
  if (true || !albumFolder) {
    return false;
  }

  const showToTypes = [ALBUM_TYPE.SHUTTERBUG];

  return (
    isMobile() &&
    !isNativeWebView &&
    showToTypes.includes(albumFolder.album_type)
  );
};

export const getBrowserName = browserName => {
  switch (browserName) {
    case 'ios':
      return 'Safari';
    case 'ie':
      return 'Internet Explorer';
    default:
      return supportedBrowsers.includes(browserName)
        ? capitalize(browserName)
        : 'Web Browser';
  }
};
